import { HttpTypes } from '@/types';
import { AdminStockResponse } from '@/types/http';
import { BaseStockHistory, BaseStockList } from '@/types/http/stocks/common';
import { ILocationData } from '@/types/location';
import { IStock, IStockUpdate } from '@/types/stock.type';
import { AxiosInstance } from 'axios';

class Stocks {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async stockCheck(data: IStockUpdate): Promise<HttpTypes.IResponse<IStock>> {
    const res = await this.client.post('/product/stocks/stock-check', data);
    return res.data;
  }

  async listStocks(
    queryParams: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<BaseStockList[]>> {
    const result = await this.client.get('/product/stocks', {
      params: queryParams,
    });
    return result.data;
  }

  async listHistoryStocks(
    id: string,
    query: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<BaseStockHistory[]>> {
    const result = await this.client.get(`/product/stocks/history/${id}`, {
      params: query,
    });
    return result.data;
  }

  async create(data: HttpTypes.AdminCreateStock): Promise<HttpTypes.IResponse<AdminStockResponse>> {
    const result = await this.client.post('/product/stocks', data);
    return result.data;
  }

  async update(data: HttpTypes.AdminUpdateStock): Promise<HttpTypes.IResponse<AdminStockResponse>> {
    const result = await this.client.put(`/product/stocks/${data.item_id}`, data);
    return result.data;
  }

  async locations(args: HttpTypes.FindParams): Promise<HttpTypes.IResponse<ILocationData[]>> {
    const result = await this.client.get('/product/stocks/locations', {
      params: args,
    });
    return result.data;
  }
}

export default Stocks;
